<script>
import Gleap from 'gleap'
import { getFullName } from '@/utils/helpers'
import { EventBus } from '@/services/event-bus'
import { mapGetters } from 'vuex'
import { getLuxonObj } from '../../utils/dateHelpers'

export default {
  data() {
    return {
      pusherEvents: [
        'crm:authorized',
        'mailbox:authorized',
        'phone:authorized',
        'onboarding:step-completed',
      ],
      unreadCount: 0,
    }
  },
  computed: {
    ...mapGetters('pusher', ['channel']),
    ...mapGetters('user', ['user', 'organization', 'isLoggedIn']),
    ...mapGetters('phone', ['phones', 'loading']),
  },
  methods: {
    openHelpChat(message) {
      Gleap.open()
      if (message) {
        // TODO: Currently have a request out to Gleap to see if they will support pre-filling the chat. If not, we can use Workflows. They are more robust and require a little more setup. For most cases this is good, but some I would still like to use pre-filled chat.
        Gleap.startConversation()
      }
    },
    openHelpForm(formId, data) {
      Gleap.open()
      Gleap.startClassicForm(formId)
      if (data) Gleap.preFillForm(data)
    },
    identifyUser() {
      Gleap.identify(
        this.user?.id,
        {
          name: getFullName(this.user?.first_name, this.user?.last_name),
          email: this.user?.email,
          phone: this.user?.contact_phone,
          // value: 199.95, - Better would be to track the value of the organization. Not sure what this does yet.
          value: this.organization?.subscription_amount
            ? this.organization.subscription_amount / 100
            : 0,
          metal_status: this.organization?.metal,
          plan: this.user.billingPlan?.name,
          companyId: this.organization?.id,
          companyName: this.organization?.name,
          customData: {
            created_at: Math.floor(
              getLuxonObj(this.user?.created_at).ts / 1000
            ),
            user_role: this.user?.role,
            is_past_otp: this.user?.otp_override || this.user?.otp_verified,
            avatar_color: this.user?.avatar_color,
            avatar_url: this.user?.avatar_url,
          },
        },
        this.user?.gleap_user_hash
      )
    },
    sendEvent(event, data = null) {
      const eventName =
        event === 'onboarding:step-completed'
          ? `${event}-${data?.stepName}`
          : event
      Gleap.trackEvent(eventName, data)
    },
    bindPusherObserver() {
      if (!this.channel) return

      this.pusherEvents.forEach((event) => {
        this.channel.bind(event, (data) => this.sendEvent(event, data))
      })
    },
    unbindPusherObserver() {
      if (!this.channel) return

      this.pusherEvents.forEach((event) => {
        this.channel.unbind(event)
      })
    },
    bindGleapEvents() {
      Gleap.on('initialized', () => {
        console.log('Gleap got initialized and is ready :)')
      })
      Gleap.on('unread-count-changed', (count) => {
        if (count < this.unreadCount) {
          this.unreadCount = count
          return
        }

        if (count === this.unreadCount) return

        if (count > 0) {
          EventBus.$emit('unread-help-center-messages', count)
          if (this.$route.fullPath !== '/dial') Gleap.openConversations()
        }
      })
    },
  },
  created() {
    this.bindGleapEvents()
    if (this.user && this.isLoggedIn) this.identifyUser()
    EventBus.$on('open-help-chat', this.openHelpChat)
    EventBus.$on('open-help-bot', (id) => {
      Gleap.startBot(id)
    })
    EventBus.$on('open-help-form', (formId, data) => {
      this.openHelpForm(formId, data)
    })
    EventBus.$on('feature-request-clicked', () => {
      Gleap.startClassicForm('featurerequests')
    })
  },
  render() {
    return true
  },
  watch: {
    channel: {
      handler(newVal) {
        if (newVal != null) {
          this.unbindPusherObserver()
          this.bindPusherObserver()
        }
      },
      immediate: true,
    },
    user() {
      if (this.user && this.userHasCalling && this.loading) return
      if (this.user && !Gleap.isUserIdentified()) this.identifyUser()
    },
    phones() {
      if (this.user && !Gleap.isUserIdentified()) this.identifyUser()
    },
    $route(route, oldRoute) {
      if (route.fullPath == '/dial' && oldRoute.fullPath != '/dial') {
        // Disable notifications in dial route
        Gleap.setDisableInAppNotifications(true)
      }
      if (route.fullPath != '/dial' && oldRoute.fullPath == '/dial') {
        // Enable notifications in dial route
        Gleap.setDisableInAppNotifications(false)
      }
    },
  },
  beforeDestroy() {
    this.unbindPusherObserver()
    EventBus.$off('open-help-chat')
    EventBus.$off('open-help-bot')
    EventBus.$off('open-help-form')
    EventBus.$off('feature-request-clicked')
  },
}
</script>
